import axios from '@/lib/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bookingDetailQueryKey } from '@/hooks/queries/use-get-booking-detail.query';
import { bookingReviewStatusQueryKey } from '@/hooks/queries/use-get-booking-review-status.query';

interface Payload {
  cleaner_id: string;
  booking_id: string;
  tip_amount_cents: number;
}

interface Response {
  success: boolean;
  earning_id: string;
  cleaner_id: string;
  amount: number;
  stripe_payment_intent_id: string;
  created_at: string;
}

const postCleanerTips = async (payload: Payload): Promise<Response> => {
  const response = await axios.post('/cleaners/tips', payload);
  return response.data;
};

export const usePostCleanerTipsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['cleaner-tips'],
    mutationFn: postCleanerTips,
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: bookingDetailQueryKey(variables.booking_id),
      });
      void queryClient.invalidateQueries({
        queryKey: bookingReviewStatusQueryKey(variables.booking_id),
      });
      void queryClient.invalidateQueries({
        queryKey: ['wallet', 'history'],
      });
    },
  });
};
